// noinspection JSUnusedGlobalSymbols

import Date from '../../../client/date.js'
import Form from '../../../client/form.js'
import Image from '../../../client/image.js'
import Is from '../../../client/is.js'
import Network from '../../../client/network.js'
import Table from '../../../client/table.js'

export default class
{
	static init()
	{
		$(() =>
		{
			Date.init()
			Form.init()
			Image.init()
			Network.init()
			Table.init()
		})
	}

	static change_site(site_id)
	{
		if(!Is.int(site_id)) return

		document.cookie = `site=${site_id}; path=/; max-age=${86400 * 365}`
		location.reload()
	}
}
